import * as Yup from "yup";

const PermissionGroupSchema = Yup.object().shape({
  name: Yup.string().required("Please enter a title").strict().trim(),
});

export default PermissionGroupSchema;
